(() => {
  'use strict';

  if (window.__plfGalleryWallStorefront) return;
  window.__plfGalleryWallStorefront = true;

  const QUEUE_KEY = 'plf_wall_queue';
  const WALL_COUNT_KEY = 'plf_wall_count';
  const FRAME_PREF_KEY = 'plf_frame_pref';
  const INTRO_KEY = 'plf_wall_intro_seen';
  const ROOT = window.Shopify?.routes?.root || window.SHOP_ROOT_URL || '/';
  const localeMatch = location.pathname.match(/^\/([a-z]{2})-[a-z]{2}(?:\/|$)/i);
  const lang = (localeMatch?.[1] || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();

  const TEXT = {
    da: { add: 'Tilføj til billedvæg', added: 'Tilføjet', introTitle: 'Tilføjet til din billedvæg!', introBody: 'Plakaten ligger nu klar i Billedvægbyggeren, hvor du kan designe din egen væg.', introGo: 'Se din billedvæg', introClose: 'Forstået', frame: 'Vis med ramme' },
    en: { add: 'Add to gallery wall', added: 'Added', introTitle: 'Added to your gallery wall!', introBody: 'The poster is now waiting in the Gallery Wall Builder, where you can design your own wall.', introGo: 'View your wall', introClose: 'Got it', frame: 'Preview with frame' },
    de: { add: 'Zur Bilderwand hinzufügen', added: 'Hinzugefügt', introTitle: 'Zur Bilderwand hinzugefügt!', introBody: 'Das Poster liegt jetzt im Bilderwand-Builder bereit, wo Sie Ihre eigene Wand gestalten können.', introGo: 'Bilderwand ansehen', introClose: 'Verstanden', frame: 'Mit Rahmen ansehen' },
    sv: { add: 'Lägg till på tavelvägg', added: 'Tillagd', introTitle: 'Tillagd på din tavelvägg!', introBody: 'Postern väntar nu i Tavelväggsbyggaren, där du kan designa din egen vägg.', introGo: 'Se din tavelvägg', introClose: 'Uppfattat', frame: 'Visa med ram' },
    fi: { add: 'Lisää tauluseinälle', added: 'Lisätty', introTitle: 'Lisätty tauluseinällesi!', introBody: 'Juliste odottaa nyt tauluseinätyökalussa, jossa voit suunnitella oman seinäsi.', introGo: 'Katso tauluseinää', introClose: 'Selvä', frame: 'Näytä kehyksellä' },
    fr: { add: 'Ajouter au mur de cadres', added: 'Ajouté', introTitle: 'Ajouté à votre mur de cadres !', introBody: 'L’affiche vous attend dans le créateur de mur de cadres pour composer votre propre mur.', introGo: 'Voir votre mur', introClose: 'Compris', frame: 'Voir avec cadre' },
    nl: { add: 'Toevoegen aan fotowand', added: 'Toegevoegd', introTitle: 'Toegevoegd aan je fotowand!', introBody: 'De poster staat klaar in de fotowand-bouwer, waar je je eigen wand kunt ontwerpen.', introGo: 'Bekijk je fotowand', introClose: 'Begrepen', frame: 'Bekijk met lijst' },
    it: { add: 'Aggiungi alla parete quadri', added: 'Aggiunto', introTitle: 'Aggiunto alla tua parete!', introBody: 'Il poster ti aspetta nel creatore di pareti, dove puoi progettare la tua composizione.', introGo: 'Vedi la parete', introClose: 'Capito', frame: 'Vedi con cornice' },
    es: { add: 'Añadir a la pared de cuadros', added: 'Añadido', introTitle: '¡Añadido a tu pared de cuadros!', introBody: 'El póster te espera en el creador de paredes, donde puedes diseñar tu composición.', introGo: 'Ver tu pared', introClose: 'Entendido', frame: 'Ver con marco' },
    pl: { add: 'Dodaj do ściany galerii', added: 'Dodano', introTitle: 'Dodano do Twojej ściany galerii!', introBody: 'Plakat czeka w kreatorze ściany galerii, gdzie możesz zaprojektować własną kompozycję.', introGo: 'Zobacz ścianę', introClose: 'Rozumiem', frame: 'Pokaż z ramą' },
  };
  const t = TEXT[lang] || TEXT.en;

  const COLORS = [
    { key: 'Oak-Nature', da: 'Eg', en: 'Oak Nature', hex: '#c9a06b' },
    { key: 'Black-Wood', da: 'Sort', en: 'Black Wood', hex: '#1c1c1c' },
    { key: 'White-Wood', da: 'Hvid', en: 'White Wood', hex: '#f2f0ec' },
    { key: 'Oak-Dark', da: 'Mørk eg', en: 'Oak Dark', hex: '#8a6a42' },
    { key: 'Grey-Wood', da: 'Grå', en: 'Grey Wood', hex: '#9a9a9a' },
    { key: 'Blue-Wood', da: 'Blå', en: 'Blue Wood', hex: '#34506e' },
    { key: 'Green-Wood', da: 'Grøn', en: 'Green Wood', hex: '#3e5c48' },
    { key: 'Teal-Wood', da: 'Petrol', en: 'Teal Wood', hex: '#2f6e6a' },
    { key: 'Red-Wood', da: 'Rød', en: 'Red Wood', hex: '#a33227' },
    { key: 'Rose-Wood', da: 'Rosa', en: 'Rose Wood', hex: '#d5a09a' },
    { key: 'Orange-Wood', da: 'Orange', en: 'Orange Wood', hex: '#cd7a33' },
    { key: 'Yellow-Wood', da: 'Gul', en: 'Yellow Wood', hex: '#d9b23a' },
    { key: 'Mint-Wood', da: 'Mint', en: 'Mint Wood', hex: '#bcd6c2' },
    { key: 'Lilac-Wood', da: 'Lilla', en: 'Lilac Wood', hex: '#b9a6cc' },
  ];

  const productCache = new Map();
  let frameThumbs = null;
  let observerTimer = null;

  const parseJson = (value, fallback) => {
    try { return JSON.parse(value); } catch { return fallback; }
  };
  const getQueue = () => {
    const value = parseJson(localStorage.getItem(QUEUE_KEY) || '[]', []);
    return Array.isArray(value) ? [...new Set(value.filter(Boolean))] : [];
  };
  const getWallCount = () => {
    const value = Number.parseInt(localStorage.getItem(WALL_COUNT_KEY) || '0', 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
  };
  const extractHandle = (value) => String(value || '').match(/\/products\/([a-z0-9-]+)/i)?.[1] || null;
  const setQueue = (queue) => {
    localStorage.setItem(QUEUE_KEY, JSON.stringify([...new Set(queue.filter(Boolean))]));
    updateBadge();
  };
  const addToQueue = (handle) => {
    const queue = getQueue();
    if (!queue.includes(handle)) queue.push(handle);
    setQueue(queue);
    return queue.length;
  };

  function builderHref() {
    return document.querySelector('a[href*="gallery-wall-builder"]')?.href || `${ROOT}pages/gallery-wall-builder`;
  }

  function injectCss() {
    if (document.getElementById('plf-gallery-wall-storefront-css')) return;
    const style = document.createElement('style');
    style.id = 'plf-gallery-wall-storefront-css';
    style.textContent = `
      .plf-wall-add-btn{display:flex;width:100%;margin-top:10px;padding:14px 18px;min-height:50px;align-items:center;justify-content:center;gap:8px;border:1.5px solid #141413;border-radius:8px;background:#fff;color:#141413;font:600 15px/1.2 inherit;cursor:pointer;transition:background .15s,color .15s}
      .plf-wall-add-btn:hover{background:#f4f2ee}.plf-wall-add-btn:focus-visible,.plf-card-chip:focus-visible,.plf-sw:focus-visible,.plf-sw-more:focus-visible{outline:2px solid #141413;outline-offset:2px}
      .plf-card-chip{position:absolute;top:10px;right:10px;z-index:20;max-width:calc(100% - 20px);display:inline-flex;align-items:center;gap:7px;padding:8px 13px;border:0;border-radius:999px;background:rgba(20,20,19,.9);color:#fff;font:600 11.5px/1 inherit;white-space:nowrap;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.18);transition:background .15s,transform .15s}
      .plf-card-chip:hover{background:#141413;transform:translateY(-1px)}
      .plf-wall-badge{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;margin-left:6px;padding:0 5px;border-radius:999px;background:#141413;color:#fff;font-size:11px;font-weight:700;vertical-align:middle}
      .plf-swbar{display:flex;align-items:center;gap:8px;margin-right:14px;flex-wrap:wrap;min-width:0}.plf-sw{width:26px;height:26px;flex:none;padding:0;border:1.5px solid rgba(0,0,0,.17);border-radius:50%;background-position:center;background-size:cover;cursor:pointer}.plf-sw--on{border-color:#141413;box-shadow:0 0 0 1.5px #141413}.plf-sw-more{flex:none;padding:6px 9px;border:0;border-radius:999px;background:#f1ede8;color:#141413;font:700 11px/1 inherit;cursor:pointer}
      .plf-swatches{position:absolute;bottom:10px;left:10px;z-index:19;display:flex;align-items:center;gap:6px;max-width:calc(100% - 20px);padding:5px 8px;overflow-x:auto;border-radius:999px;background:rgba(255,255,255,.94);box-shadow:0 1px 4px rgba(0,0,0,.14);scrollbar-width:none}.plf-swatches::-webkit-scrollbar{display:none}.plf-swatches .plf-sw{width:22px;height:22px}
      @media(hover:hover) and (pointer:fine){product-card .product-media,product-card slideshow-component{overflow:hidden}product-card .product-media img,product-card slideshow-component img{transition:transform .35s ease;will-change:transform}}
      @media(max-width:749px){.plf-card-chip{width:36px;height:36px;padding:0;justify-content:center;font-size:16px}.plf-card-chip__text{display:none}.plf-swbar,.plf-swatches{display:none!important}}
    `;
    document.head.appendChild(style);
  }

  function updateBadge() {
    const count = getWallCount() + getQueue().length;
    document.querySelectorAll('a[href*="gallery-wall-builder"]').forEach((link) => {
      if (link.closest('.mega-menu-images')) return;
      let badge = link.querySelector('.plf-wall-badge');
      if (!count) { badge?.remove(); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'plf-wall-badge';
        link.appendChild(badge);
      }
      badge.textContent = String(count);
      badge.setAttribute('aria-label', String(count));
    });
  }

  function showIntro() {
    if (localStorage.getItem(INTRO_KEY)) return;
    localStorage.setItem(INTRO_KEY, '1');
    const background = document.createElement('div');
    background.className = 'plf-wall-intro';
    background.style.cssText = 'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(20,20,19,.5)';
    const dialog = document.createElement('div');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.style.cssText = 'width:min(380px,100%);padding:26px 24px;text-align:center;border-radius:18px;background:#fff;box-shadow:0 14px 50px rgba(0,0,0,.3)';
    const title = document.createElement('h3');
    title.textContent = t.introTitle;
    title.style.cssText = 'margin:0 0 8px;font-size:19px';
    const body = document.createElement('p');
    body.textContent = t.introBody;
    body.style.cssText = 'margin:0 0 18px;color:#555;font-size:14px;line-height:1.5';
    const link = document.createElement('a');
    link.href = builderHref();
    link.textContent = t.introGo;
    link.style.cssText = 'display:block;margin-bottom:8px;padding:13px;border-radius:10px;background:#141413;color:#fff;text-decoration:none;font-size:14.5px;font-weight:600';
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = t.introClose;
    close.style.cssText = 'padding:8px;border:0;background:none;color:#777;font-size:13.5px;cursor:pointer';
    close.addEventListener('click', () => background.remove());
    background.addEventListener('click', (event) => { if (event.target === background) background.remove(); });
    dialog.append(title, body, link, close);
    background.appendChild(dialog);
    document.body.appendChild(background);
  }

  function injectProductButton() {
    const handle = extractHandle(location.pathname);
    if (!handle || document.querySelector('.plf-wall-add-btn')) return;
    const anchor = document.querySelector('.addtocartbutton') || document.querySelector('#addToCart')?.parentElement;
    if (!anchor) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'plf-wall-add-btn';
    button.setAttribute('aria-label', t.add);
    button.innerHTML = `<span aria-hidden="true">⊞</span><span>${t.add}</span>`;
    button.addEventListener('click', () => {
      const count = addToQueue(handle);
      showIntro();
      button.innerHTML = `<span aria-hidden="true">✓</span><span>${t.added} (${count})</span>`;
      window.setTimeout(() => { button.innerHTML = `<span aria-hidden="true">⊞</span><span>${t.add}</span>`; }, 2200);
    });
    anchor.insertAdjacentElement('afterend', button);
  }

  function productCardData(card) {
    const link = card.querySelector('.product-card__link[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    const handle = extractHandle(link?.getAttribute('href'));
    const media = card.querySelector('.product-media') || card.querySelector('slideshow-component') || card.querySelector('img')?.parentElement;
    return { link, handle, media };
  }

  function initHoverZoom() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const zoom = 1.6;
    const mediaFrom = (target) => target?.closest?.('product-card .product-media, product-card slideshow-component') || null;
    const imageFrom = (media) => media?.querySelector('img:not([hidden])') || media?.querySelector('img') || null;

    document.addEventListener('pointerover', (event) => {
      const media = mediaFrom(event.target);
      const image = imageFrom(media);
      if (image) image.style.transform = `scale(${zoom})`;
    }, { passive: true });

    document.addEventListener('pointermove', (event) => {
      const media = mediaFrom(event.target);
      const image = imageFrom(media);
      if (!media || !image) return;
      const rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      image.style.transformOrigin = `${x}% ${y}%`;
      image.style.transform = `scale(${zoom})`;
    }, { passive: true });

    document.addEventListener('pointerout', (event) => {
      const media = mediaFrom(event.target);
      if (!media || (event.relatedTarget && media.contains(event.relatedTarget))) return;
      const image = imageFrom(media);
      if (image) {
        image.style.transform = '';
        image.style.transformOrigin = '';
      }
    }, { passive: true });
  }

  function injectCardChips() {
    document.querySelectorAll('product-card').forEach((card) => {
      if (card.closest('#sidewishlist,[data-plf-wishlist-page],[data-tab="favorites"]')) return;
      if (card.querySelector('.plf-card-chip')) return;
      const { handle, media } = productCardData(card);
      if (!handle || !media || !media.querySelector('img')) return;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'plf-card-chip';
      chip.title = t.add;
      chip.setAttribute('aria-label', t.add);
      chip.innerHTML = `<span aria-hidden="true">⊞</span><span class="plf-card-chip__text">${t.add}</span>`;
      chip.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const count = addToQueue(handle);
        showIntro();
        chip.innerHTML = `<span aria-hidden="true">✓</span><span class="plf-card-chip__text">${t.added} (${count})</span>`;
        window.setTimeout(() => { chip.innerHTML = `<span aria-hidden="true">⊞</span><span class="plf-card-chip__text">${t.add}</span>`; }, 1800);
      });
      media.appendChild(chip);
    });
  }

  function fetchProduct(handle) {
    if (!productCache.has(handle)) {
      const prefix = ROOT.endsWith('/') ? ROOT : `${ROOT}/`;
      productCache.set(handle, fetch(`${prefix}products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : null).catch(() => null));
    }
    return productCache.get(handle);
  }

  async function loadFrameThumbs() {
    if (frameThumbs) return frameThumbs;
    frameThumbs = {};
    try {
      const response = await fetch('/en-us/products/frames.js', { headers: { Accept: 'application/json' } });
      const product = response.ok ? await response.json() : null;
      const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z]/g, '');
      COLORS.forEach((color) => {
        const variant = product?.variants?.find((candidate) => normalize(candidate.option2) === normalize(color.en) && candidate.featured_image);
        if (variant) frameThumbs[color.key] = variant.featured_image.src;
      });
    } catch { /* Hex-farverne er den sikre fallback. */ }
    return frameThumbs;
  }

  function primaryCardImage(card) {
    return card.querySelector('.product-media img:not([hidden])') || card.querySelector('slideshow-component img') || card.querySelector('img');
  }

  function swapCardImage(card, colorKey) {
    const { handle } = productCardData(card);
    const image = primaryCardImage(card);
    if (!handle || !image) return;
    fetchProduct(handle).then((product) => {
      const needle = `/files/${colorKey.toLowerCase()}-`;
      const hit = product?.images?.find((url) => String(url).toLowerCase().includes(needle));
      if (!hit) return;
      if (!image.dataset.plfOriginalSrc) {
        image.dataset.plfOriginalSrc = image.currentSrc || image.src;
        image.dataset.plfOriginalSrcset = image.getAttribute('srcset') || '';
      }
      image.removeAttribute('srcset');
      image.src = hit.startsWith('//') ? `https:${hit}` : hit;
    });
  }

  function resetCards() {
    localStorage.removeItem(FRAME_PREF_KEY);
    document.querySelectorAll('product-card img[data-plf-original-src]').forEach((image) => {
      image.src = image.dataset.plfOriginalSrc;
      if (image.dataset.plfOriginalSrcset) image.setAttribute('srcset', image.dataset.plfOriginalSrcset);
      else image.removeAttribute('srcset');
    });
    document.querySelectorAll('.plf-sw').forEach((swatch) => swatch.classList.remove('plf-sw--on'));
  }

  function applyFramePreference() {
    const key = localStorage.getItem(FRAME_PREF_KEY);
    if (!key) return;
    document.querySelectorAll('product-card').forEach((card) => swapCardImage(card, key));
  }

  function chooseFrame(color) {
    if (localStorage.getItem(FRAME_PREF_KEY) === color.key) {
      resetCards();
      return;
    }
    localStorage.setItem(FRAME_PREF_KEY, color.key);
    document.querySelectorAll('.plf-sw').forEach((swatch) => swatch.classList.toggle('plf-sw--on', swatch.dataset.key === color.key));
    applyFramePreference();
  }

  function makeSwatch(color) {
    const swatch = document.createElement('button');
    swatch.type = 'button';
    swatch.className = `plf-sw${localStorage.getItem(FRAME_PREF_KEY) === color.key ? ' plf-sw--on' : ''}`;
    swatch.dataset.key = color.key;
    swatch.title = `${t.frame}: ${lang === 'da' ? color.da : color.en}`;
    swatch.setAttribute('aria-label', swatch.title);
    swatch.style.backgroundColor = color.hex;
    if (frameThumbs?.[color.key]) swatch.style.backgroundImage = `url("${frameThumbs[color.key]}")`;
    swatch.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      chooseFrame(color);
    });
    return swatch;
  }

  function frameThumbsReady() {
    return Boolean(frameThumbs) && COLORS.every((color) => Boolean(frameThumbs[color.key]));
  }

  function appendSwatches(container, visible = 3) {
    COLORS.slice(0, visible).forEach((color) => container.appendChild(makeSwatch(color)));
    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'plf-sw-more';
    more.textContent = `+${COLORS.length - visible}`;
    more.setAttribute('aria-label', `${t.frame}: +${COLORS.length - visible}`);
    more.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      more.remove();
      COLORS.slice(visible).forEach((color) => container.appendChild(makeSwatch(color)));
    });
    container.appendChild(more);
  }

  function ensureToolbarSwatches() {
    // Never render the temporary hex fallbacks. The toolbar and card controls
    // must contain the real frame thumbnails only.
    if (!frameThumbsReady() || !/\/collections\//.test(location.pathname) || document.getElementById('plf-swbar')) return;
    const sort = document.querySelector('.sorting-filter,[data-sorting-filter],.facets__sorting,select[name="sort_by"]');
    const host = sort?.parentElement || document.querySelector('.facets__form,.facets__wrapper,.collection-toolbar');
    if (!host) return;
    const bar = document.createElement('div');
    bar.id = 'plf-swbar';
    bar.className = 'plf-swbar';
    appendSwatches(bar);
    if (sort && sort.parentElement === host) host.insertBefore(bar, sort);
    else host.appendChild(bar);
  }

  function injectCardSwatches() {
    if (!frameThumbsReady()) return;
    document.querySelectorAll('product-card').forEach((card) => {
      if (card.querySelector('.plf-swatches')) return;
      const { media } = productCardData(card);
      if (!media || !media.querySelector('img')) return;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      const row = document.createElement('div');
      row.className = 'plf-swatches';
      appendSwatches(row);
      row.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); });
      media.appendChild(row);
    });
    applyFramePreference();
  }

  function bridgeBuilder() {
    const iframe = document.querySelector('.posterlefi-inline-iframe');
    if (!iframe || iframe.dataset.plfQueueBridge === 'true') return;
    iframe.dataset.plfQueueBridge = 'true';
    const send = () => {
      const queue = getQueue();
      if (queue.length) iframe.contentWindow?.postMessage({ plfWallQueue: queue }, '*');
    };
    iframe.addEventListener('load', () => window.setTimeout(send, 1200));
    window.setTimeout(send, 2500);
  }

  function handleBuilderMessage(event) {
    if (event.data?.plfWallQueueConsumed) setQueue([]);
    if (typeof event.data?.plfWallCount === 'number') {
      localStorage.setItem(WALL_COUNT_KEY, String(event.data.plfWallCount));
      updateBadge();
    }
  }

  function enhance() {
    injectProductButton();
    injectCardChips();
    ensureToolbarSwatches();
    injectCardSwatches();
    updateBadge();
    bridgeBuilder();
  }

  function boot() {
    injectCss();
    initHoverZoom();
    window.addEventListener('message', handleBuilderMessage);
    loadFrameThumbs().finally(enhance);
    enhance();
    const observer = new MutationObserver(() => {
      if (observerTimer) return;
      observerTimer = window.setTimeout(() => {
        observerTimer = null;
        observer.disconnect();
        try { enhance(); } finally { observer.observe(document.body, { childList: true, subtree: true }); }
      }, 350);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
